import React, { useState } from "react";
import Details from "../Components/EternalSeptember/Details";
import ModelDemo from "../Components/EternalSeptember/ModelDemo";
import ResearchDevelopment from "../Components/EternalSeptember/ResearchDevelopment";
import "../css/pages/eternal-september.css";

const components = {
  details: <Details />,
  research: <ResearchDevelopment />,
  model: <ModelDemo />
};

function EternalSeptember() {
  const [currentPage, setCurrentPage] = useState("details");

  const renderComponent = () => {
    return components[currentPage];
  };

  const handleNavigation = (pageName) => {
    setCurrentPage(pageName);
  };

  return (
    <div className="w-100 center f-col">
      <h2 className="es-title">Eternal September Lab</h2>
      <div className="navigation-buttons">
        <button onClick={() => handleNavigation("details")}>Details</button>
        <button onClick={() => handleNavigation("research")}>
          R & D
        </button>
        <button onClick={() => handleNavigation("model")}>Demo</button>
      </div>
      <div>
        {renderComponent()}
      </div>
    </div>
  );
}

export default EternalSeptember;